import { render, staticRenderFns } from "./AwardListDetail.vue?vue&type=template&id=36ca6110"
import script from "./AwardListDetail.vue?vue&type=script&lang=js"
export * from "./AwardListDetail.vue?vue&type=script&lang=js"
import style0 from "./AwardListDetail.vue?vue&type=style&index=0&id=36ca6110&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports